import { CloneModal } from '../cloneme-classes/CloneModal';
import { Elements } from '../cloneme-classes/Elements';
import { FetchData } from '../cloneme-classes/FetchData';
import { GenericModals } from '../cloneme-classes/GenericModals';
import { UserManager } from '../services/UserManager';
import { retargetSubscribeLinks } from '../utils';

export class ConsumerPage {
  elements: Elements = new Elements();
  private userManager: UserManager | undefined;

  public async init(): Promise<void> {
    this.userManager = await UserManager.getInstance();
    const modals = new CloneModal();
    modals.init();

    this.setBackButtons();
    this.addWindowEventListeners();
    this.setVideoThumbnails();

    const genericModals = new GenericModals();
    genericModals.init();

    this.checkUserSubscriptionAndTokens = this.checkUserSubscriptionAndTokens.bind(this);

    this.chatWithMeButtonLogic();
    this.listenForIframeMessages();
  }

  private listenForIframeMessages(): void {
    window.addEventListener('message', (event: MessageEvent) => {
      if (typeof event.data !== 'string') return;
      try {
        const data = JSON.parse(event.data);
        if (data.action !== 'update::errors') return;
        const parsed = typeof data.data === 'string' ? JSON.parse(data.data) : data.data;
        const code = parsed?.error;
        if (code === 'trial_exceeded') {
          this.showSubscribePopup();
        } else if (code === 'tokens_exhausted') {
          this.showBuyTokensPopup();
        }
      } catch (e) {
        console.warn('[ConsumerPage] iframe message parse failed', e);
      }
    });
  }

  public showSubscribePopup() {
    const popup = document.querySelector('[cc-element="generic-modal"]') as HTMLElement | null;
    if (popup) {
      retargetSubscribeLinks(popup);
      popup.classList.remove('hide');
      popup.style.opacity = '1';
      popup.style.visibility = 'visible';
      popup.style.display = 'flex';
    }
  }

  public showBuyTokensPopup() {
    const btn = document.querySelector('[cc-element="PurchaseTokensPopUpButton"]') as HTMLAnchorElement | null;
    btn?.click();
  }

  public addWindowEventListeners() {
    // On Page Load
    window.addEventListener('load', () => {
      // Check if the back button was used
      if (localStorage.getItem('usedBackButton') === 'true') {
        const savedPosition = localStorage.getItem('returnScrollPosition');
        if (savedPosition) {
          window.scrollTo(0, parseInt(savedPosition));
          // Clear the stored position and the flag
          localStorage.removeItem('returnScrollPosition');
          localStorage.removeItem('usedBackButton');
        }
      }
    });

    // Before Unload Event
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('scrollPosition', window.scrollY.toString());
    });
  }

  public setVideoThumbnails() {
    // Look for videos on the page
    const videoThumbnails = this.elements.getAll(
      'videoThumbnail'
    ) as unknown as NodeListOf<HTMLVideoElement>;

    if (videoThumbnails) {
      videoThumbnails.forEach((videoElement: HTMLVideoElement) => {
        // Using parentElement to get the parent node
        const { parentElement } = videoElement;
        if (parentElement) {
          const videoUrl = parentElement.getAttribute('video-url');

          if (videoUrl && this.isValidUrl(videoUrl)) {
            videoElement.src = '';
            videoElement.load();
            // Remove all existing source elements
            while (videoElement.firstChild) {
              videoElement.removeChild(videoElement.firstChild);
            }
            // Create a new source element
            const source = document.createElement('source');
            source.setAttribute('src', videoUrl);
            source.setAttribute('type', 'video/mp4');

            // Clear existing content and append the new source

            videoElement.innerHTML = '';
            videoElement.appendChild(source);
            videoElement.src = videoUrl;
            // Load the new source in the video element
            videoElement.load();
          }
        }
      });
    }
  }

  public setBackButtons() {
    // Back Button Click Event
    const backButtons = document.querySelectorAll('[cc-element="back-history-button"]');
    backButtons.forEach(function (backButton) {
      backButton.addEventListener('click', function (event) {
        event.preventDefault();
        // Store the current scroll position in localStorage
        localStorage.setItem('returnScrollPosition', window.scrollY.toString());
        // Set a flag indicating the back button was used
        localStorage.setItem('usedBackButton', 'true');
        window.history.back();
      });
    });
  }

  public chatWithMeButtonLogic() {
    this.userManager?.hasActiveSubscription;
    const chatWithMeButton = document.getElementById('chat-with-me-button');
    chatWithMeButton?.addEventListener('click', (event) => {
      FetchData.callIfLoggedIn(this.checkUserSubscriptionAndTokens);
    });
  }

  public checkUserSubscriptionAndTokens() {
    if (this.userManager && this.userManager.wallet.tokens > 0) {
      const chatWithMePopupTriggerButton = document.querySelector(
        '[cc-element = "open-modal"]'
      ) as HTMLAnchorElement;

      if (chatWithMePopupTriggerButton) {
        chatWithMePopupTriggerButton.click();
      }
    } else {
      if (this.userManager && this.userManager.hasActiveSubscription) {
        const PurchaseTokensPopUpButton = document.querySelector(
          '[cc-element="PurchaseTokensPopUpButton"]'
        ) as HTMLAnchorElement;
        PurchaseTokensPopUpButton.click();
      } else {
        const subscribeNowPopup = document.querySelector(
          '[cc-element="generic-modal"]'
        ) as HTMLElement;
        if (subscribeNowPopup) {
          subscribeNowPopup?.classList.remove('hide');
          subscribeNowPopup.style.opacity = '1';
          subscribeNowPopup.style.visibility = 'visible';
          subscribeNowPopup.style.display = 'flex';
        }
      }
    }
  }

  public isValidUrl(string: string) {
    const regex =
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
    return regex.test(string);
  }
}
